import React from "react";
import "./styles.scss";
import { CardCustom } from "components/molecules";
import { Button } from "components/atoms";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ListCards = ({ list, isList, isTitle }: any) => {
  const navigate = useNavigate();
    const { t } = useTranslation();

  return (
    <div className="listcards">
      <div className="listcards__container">
        {list.map((item: any, index: number) => (
          <div className="listcards__container--card" key={index}>
            <CardCustom
              type={"cuotas-sin-intereses"}
              data={item.card}
              redirection={item.redireccion}
            />

            {isList && item.description && (
              <div className="listcards__container--description">
                <ul>
                  {item.description.map((descItem: any, descIndex: number) => (
                    <li key={descIndex}>{descItem.content}</li>
                  ))}
                </ul>
                <b className="tyc-text">{t("listPromotionCards.termsAndConditions")}</b>
                
                <Button type="icongold" onClick={() => navigate(item.redireccion)}>
                  {t("listPromotionCards.seePromotion")}
                </Button>
              </div>
            )}
            {isTitle && (
              <div className="listcards__container--description">
                <p className="title">{item.title}</p>
                <p className="restriction">{item.restriction}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ListCards;
